/* eslint-disable prettier/prettier */
import { Button, ButtonText, Text, View } from '@gluestack-ui/themed'
import _ from 'lodash'
import React, { FunctionComponent } from 'react'
import { Image, StyleSheet } from 'react-native'
import Modal from 'react-native-modal'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { useSelector } from 'react-redux'
import { MapMessage, RealTimeMapItem } from '../../../api/CartographyRealTime/type'
import { i18n } from '../../../lib/i18n'
import { themeSelector } from '../../../redux/theme/selector'
import { getItemAction } from '../../../services/itemAction'
import { theme as themeBase } from '../../../theme'

interface ModalRealTimeProps {
  item: RealTimeMapItem | null
  onClose: () => void
  isVisible: boolean
  onReload: (interval: number | null) => void
}

const BORDER_RADIUS = 15
const MIN_HEIGHT = 130
const IMAGE_SIZE = 20

export const ModalTideTime: FunctionComponent<ModalRealTimeProps> = ({ item, isVisible, onClose }) => {
  const theme = useSelector(themeSelector)
  const insets = useSafeAreaInsets()
  if (!item) {
    return null
  }

  const renderTideLigne = (tideLigne: MapMessage) => (
    <View style={styles.tideIconText}>
      {tideLigne.iconInfo ? <Image source={{ uri: tideLigne.iconInfo }} style={styles.image} /> : null}
      <Text style={{ color: tideLigne.color }}>{tideLigne.message}</Text>
    </View>
  )

  const renderCurrentAttendance = (item: RealTimeMapItem) => {
    if (item.info) {
      const firstTide = item.info.messages[0]
      const lastTide = item.info.messages.slice(1)
      return (
        <View style={styles.viewTide}>
          <View style={styles.tideIconText}>
            <Text style={[styles.tideTimeNow, { color: theme?.brandPrimary }]}>{i18n.t('tideTime.now')} </Text>
            <Text style={{ color: firstTide.color }}>{firstTide.message}</Text>
          </View>
          <View style={styles.ligne} />
          {_.map(lastTide, element => renderTideLigne(element))}
          <Text style={styles.theoretical} numberOfLines={2}>
            {i18n.t('tideTime.theoretical')}
          </Text>
        </View>
      )
    }
    return null
  }

  const renderConsulterButton = (item: RealTimeMapItem) => {
    if (item.info && item.info.action) {
      const itemAction = item.info.action
      if (itemAction === null) {
        return null
      }

      const bgColor = theme ? theme.brandPrimary : 'blue'
      return (
        <View style={styles.viewButton}>
          <Button style={[styles.button, { backgroundColor: bgColor }]} onPress={getItemAction(itemAction)}>
            <ButtonText color={themeBase.colors.white}>{i18n.t('notifications.moreInfo')}</ButtonText>
          </Button>
        </View>
      )
    }
    return null
  }

  return (
    <Modal isVisible={isVisible} style={styles.bottomModal} swipeDirection={['down']} hasBackdrop={false} coverScreen={false} onSwipeComplete={onClose}>
      <View style={[styles.content, { paddingBottom: themeBase.padding.x6 + insets.bottom }]}>
        <View style={styles.titleContainer}>
          <Text style={styles.title} numberOfLines={1}>
            {item.title}
          </Text>
        </View>
        {renderCurrentAttendance(item)}
        {renderConsulterButton(item)}
      </View>
    </Modal>
  )
}

const styles = StyleSheet.create({
  bottomModal: {
    justifyContent: 'flex-end',
    margin: 0,
  },
  content: {
    padding: themeBase.padding.x6,
    minHeight: MIN_HEIGHT,
    backgroundColor: themeBase.colors.white,
    borderTopLeftRadius: BORDER_RADIUS,
    borderTopRightRadius: BORDER_RADIUS,
    borderTopColor: themeBase.colors.silver,
    borderLeftColor: themeBase.colors.silver,
    borderRightColor: themeBase.colors.silver,
    borderTopWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  titleContainer: {
    textAlign: 'left',
    marginRight: themeBase.padding.x1,
    marginBottom: themeBase.padding.x1,
  },
  viewTide: {},
  viewButton: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  button: { flex: 1, justifyContent: 'center', alignItems: 'center', marginTop: themeBase.padding.x3 },
  ligne: {
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderWidth: 1,
    borderColor: themeBase.colors.silver,
    marginBottom: themeBase.padding.x2,
  },
  image: {
    height: IMAGE_SIZE,
    width: IMAGE_SIZE,
    marginRight: themeBase.padding.x2,
  },
  title: {
    fontWeight: 'bold',
    fontSize: themeBase.textSize.x3,
    lineHeight: themeBase.textSize.x3,
  },
  theoretical: {
    fontStyle: 'italic',
    fontSize: themeBase.textSize.x1_25,
    marginTop: themeBase.padding.x2,
  },
  tideTimeNow: { fontWeight: 'bold', marginRight: themeBase.padding.x2 },
  tideIconText: { flexDirection: 'row', marginBottom: themeBase.padding.x2 },
})
